import { createStackNavigator } from '@react-navigation/stack'
import { useEffect } from 'react'
import { PreventBack } from '../../comps/PreventBackModal'
import { Toast, ToastPosition, ToastType } from '../../comps/Toast'
import { useStores } from '../../data/store'
import { isSessionValid } from '../../util/util'
import { Routes } from '../routes'

import QrAgentLogin from '../../screens/QrAgentPortal/login'
import MidList from '../../screens/QrAgentPortal/midlist'
import QrAgentOtp from '../../screens/QrAgentPortal/otp'
import Review from '../../screens/QrAgentPortal/review'
import ScanQrCode from '../../screens/QrAgentPortal/scanqr'
import Status from '../../screens/QrAgentPortal/status'

const Stack = createStackNavigator()

export const getInitialRouteName = () => {
  const sessData = window.localStorage.getItem('csoSessData')
  return sessData && sessData.length > 0 && isSessionValid(sessData) ? Routes.midslist : Routes.QrAgentLogin
}

const QrAgentPortalNav = () => {
  const { updateSession, errorMessage, resetMessage, updateMobile } = useStores((store) => ({
    updateSession: store?.agentQrSession?.updateSessionData,
    errorMessage: store?.response?.getMessage(),
    resetMessage: store?.response?.resetMessage,
    updateMobile: store?.agentQrUser?.updateMobileNumber,
  }))

  const getFromLocal = () => {
    const sData = window.localStorage.getItem('csoSessData')
    const mobile = window.localStorage.getItem('csoUserMobileNumber')
    if (sData !== null && sData.length > 0) {
      const jsonValue = JSON.parse(sData)
      updateSession(jsonValue)
    }
    if (mobile) {
      updateMobile(JSON.parse(mobile))
    }
  }

  useEffect(() => {
    getFromLocal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <PreventBack />
      <Stack.Navigator initialRouteName={getInitialRouteName()} screenOptions={{ headerShown: false }}>
        <Stack.Screen name={Routes.QrAgentLogin} component={QrAgentLogin} />
        <Stack.Screen name={Routes.QrAgentOtp} component={QrAgentOtp} />
        <Stack.Screen name={Routes.scanqr} component={ScanQrCode} />
        <Stack.Screen name={Routes.midslist} component={MidList} />
        <Stack.Screen name={Routes.review} component={Review} />
        <Stack.Screen name={Routes.status} component={Status} />
      </Stack.Navigator>
      <Toast
        message={errorMessage.message}
        hide={errorMessage.message === ''}
        position={ToastPosition.BOTTOM}
        type={ToastType.NEGATIVE}
        onDismiss={() => resetMessage()}
        timeOut={5000}
      />
    </>
  )
}

export { QrAgentPortalNav as default }
